import Index from 'src/pages/Suppliers/ContactPeople/Index.vue'
import Create from 'src/pages/Suppliers/ContactPeople/Create.vue'
import Edit from 'src/pages/Suppliers/ContactPeople/Edit.vue'

const auth = { requiresAuth: true }
const saveFrom = { saveFrom: true }

export default [
  {
    path: '/suppliers/:sid/contact_people',
    name: 'Ansprechpartner',
    component: Index,
    meta: auth
  },
  {
    path: '/suppliers/:sid/contact_people/create',
    name: 'Ansprechpartner Erstellen',
    component: Create,
    meta: { ...auth, ...saveFrom }
  },
  {
    path: '/suppliers/:sid/contact_people/:cpid/edit',
    name: 'Ansprechpartner Bearbeiten',
    component: Edit,
    meta: { ...auth, ...saveFrom }
  }
]
